import styled from "styled-components"

import Button from "~/components/atoms/Button"
import FavoriteButton from "~/components/molecules/FavoriteButton"
import { Shadow, SpacingSize } from "~/consts/style-mixins"

interface Props {
  buttonLabel: string
  onClickButton: Function
  onClickIcon: Function
  isFavorited: boolean
  disabled?: boolean
  className?: string
}

const ActionBar = ({ buttonLabel, onClickButton, onClickIcon, isFavorited, disabled, className }: Props) => {
  return (
    <StyledActionBarWrapper className={className}>
      <StyledFavoriteButton isFavorited={isFavorited} onClick={onClickIcon} size="Medium" />
      <StyledButton size="Medium" onClick={onClickButton} disabled={disabled}>
        {buttonLabel}
      </StyledButton>
    </StyledActionBarWrapper>
  )
}

const StyledActionBarWrapper = styled.div`
  width: 100%;
  display: flex;
  margin: auto;
`

const StyledFavoriteButton = styled(FavoriteButton)`
  margin-right: ${SpacingSize.XS}px;
  width: 48px;
  ${Shadow.Deep};
`

const StyledButton = styled(Button)`
  flex-grow: 1;
  flex: 1;
  ${Shadow.Deep};
`

export default ActionBar
